import React from 'react';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const DataUnitsInfoSkeleton = () => {
  return (
    <div className={style.unitsInfoFields}>
      <SkeletonBlock className={style.skeletonField} />
      <div className={style.tabFieldsWrapper}>
        <SkeletonBlock className={style.skeletonField} />
        <SkeletonBlock className={style.skeletonField} />
      </div>
    </div>
  );
};

export default DataUnitsInfoSkeleton;
